import {
  Children,
  FC,
  ReactElement,
  ReactNode,
  useEffect,
  useState,
} from "react";
import TabWithIconPanel, { TabWithIconPanelProps } from "./TabWithIconPanel";
import style from "./tabsWithIcons.module.css";
import {
  addQueryStrings,
  getQueryValue,
  removeQueryStrings,
} from "../../../utilities/URLUtilities_OBSOLETE";

type TabsWithIconsProps = {
  id: string;
  className?: string;
  name: string;
  selected?: number;
  children?:
    | ReactElement<TabWithIconPanelProps>
    | ReactElement<TabWithIconPanelProps>[];
  onSelect?: (e: any) => void;
  stateControlled?: boolean; // To let know that their state is controlled from outside, this was created when the state is storage on recoil and queryString (both).
  disableQueryString?: boolean; // When you do not need to add queryString to the URL
  tabsWidth?: string;
  actionBar?: ReactNode | JSX.Element;
};

const getInitialSelect = (name, stateControlled, selected) => {
  const queryState = getQueryValue(name) != "" ? getQueryValue(name) : "0";
  return stateControlled ? selected : parseInt(queryState);
};

const TabsWithIcons: FC<TabsWithIconsProps> = ({
  id,
  className,
  name,
  selected,
  children,
  onSelect,
  stateControlled,
  disableQueryString,
  tabsWidth,
  actionBar,
}) => {
  const childrenArray = Children.toArray(
    children
  ) as ReactElement<TabWithIconPanelProps>[];
  const valueSelected = getInitialSelect(name, stateControlled, selected);
  const [selectedTab, setSelectedTab] = useState<number>(valueSelected);

  const handleSelect = (value) => {
    onSelect?.(value);
    setSelectedTab(value);
  };

  useEffect(() => {
    onSelect?.(selectedTab);
    if (!disableQueryString) {
      addQueryStrings([{ nameOfHash: name, valueOfHash: selectedTab }]);
    }
  }, [selectedTab]);

  useEffect(() => {
    setSelectedTab(selected ?? 0);
  }, [selected]);

  useEffect(() => {
    return () => {
      removeQueryStrings([name]);
    };
  }, []);

  return (
    <div
      id={id}
      true-element={`true-element-tab-container-${name}`}
      className={`${style.tabs_container} ${className}`}
    >
      <div className={`${style.tabs_options_container}`}>
        {childrenArray?.map((tab, index) => (
          <TabWithIconPanel
            key={index}
            {...tab.props}
            selected={index === selectedTab}
            onClick={() => handleSelect(index)}
            width={tab.props.width ?? tabsWidth}
          />
        ))}
        {actionBar && (
          <div className={style.action_bar_wrapper}>{actionBar}</div>
        )}
      </div>
      <div className={`${style.selected_tab_content}`}>
        {childrenArray?.[selectedTab]?.props?.children}
      </div>
    </div>
  );
};

export default TabsWithIcons;
